import React from 'react';
import styles from './CheckboxList.styl';

class CheckboxList extends React.Component
{
	constructor(props) {
		super(props);
		this.onItemCheck = this.onItemCheck.bind(this);
	}

	onItemCheck(value) {
		if (this.props.onItemCheck) {
			this.props.onItemCheck(value);
		}
	}

	render() {
		let items = this.props.items.map((value) => {

			// для конфигураторов electTechCloset и electTechCloset_accessory
			if(this.props.abbreviation) {
				const abbreviation = this.props.abbreviation.filter(item => item.article === value)
				return (
					<CheckboxListItem
						key={value}
						label={abbreviation[0].abbreviation}
						value={value}
						checked={this.props.selectedValue === value}
						onItemCheck={e => this.onItemCheck(value)}
					/>
				)
			}

			return (
				<CheckboxListItem
					key={value}
					label={value}
					value={value}
					checked={this.props.selectedValue === value}
					onItemCheck={e => this.onItemCheck(value)}
				/>
			);
		});

		return <div className={this.props.className ? this.props.className : styles.list}>{items}</div>;
	}
}

class CheckboxListItem extends React.Component
{
	render() {
		let inputProps = {
			className: styles.checkbox,
			type: 'checkbox',
			value: this.props.value,
			checked: this.props.checked,
			onChange: this.props.onItemCheck
		};

		return (
			<label className={this.props.checked ? styles.itemChecked : styles.item}>
				<input {...inputProps} />
				<span className={styles.name}>{this.props.label}</span>
			</label>
		);
	}
}

export default CheckboxList;



// WEBPACK FOOTER //
// ./src/react/ui/CheckboxList.jsx